import React from 'react';
import Navigation from "../../components/navigation";
import {Stack} from "@mui/material";
import {Outlet} from "react-router";
import {HELP_NAV_LINK} from "../../constants/helpNavLink";

const AppReviewer = () => {

    const navLinks = [
        {destination: "/products", label: "Products"},
        {destination: "/charts", label: "Charts"},
        {destination: "/icr", label: "Requirements", activePrefixes: ["/icr"]},
        {destination: "/experts", label: "Experts"},
        {destination: "feed", label: "Feeds"},
        {destination: "kb", label: "KB"},
        {destination: "workflow", label: "Workflow"},
        HELP_NAV_LINK,
    ]

    return (
        <Stack height={'100vh'} overflow={'hidden'}>
            <Navigation navLinks={navLinks}/>
            <Stack flex={1} overflow={'auto'}>
                <Outlet/>
            </Stack>
        </Stack>
    );
};

export default AppReviewer;